
const RAC = [
    {
        key: "patente",
        label: "Patente",
        sortable: true,
    },
    {
        key: "contrato",
        label: "Nro. contrato",
        sortable: true,
    },
    {
        key: "valor",
        label: "Valor",
        sortable: true,
    },
    {
        key: "juzgado",
        label: "Nro. juzgado",
        sortable: true,
    },
    {
        key: "fechaInfraccion",
        label: "Fecha infracción",
        sortable: true,
    },
    {
        key: "hora",
        label: "Hora",
        sortable: true,
    },
    {
        key: "tipoInfraccion",
        label: "Tipo de infracción",
        sortable: true,
    },
    {
        key: "fechaRecepcion",
        label: "Fecha de recepción",
        sortable: true,
    },
    {
        key: "fechaPago",
        label: "Fecha de pago",
        sortable: true,
    },
    {
        key: "nombreUsuario",
        label: "Nombre conductor",
        sortable: true,
    },
    {
        key: "idDocumentoMulta",
        label: "Descargar documento",
        sortable: false,
    },
    {
        key: "idDocumentoPago",
        label: "Descargar pago documento",
        sortable: false,
    }

];
const RACData = [
    {
        patente: "AAA123",
        contrato: "123456",
        valor: "13000",
        juzgado: "Nº 1",
        fecha_infraccion: "01-04-21",
        hora: "10:00:00",
        tipo_infraccion: "Mal parqueo",
        fecha_recepcion: "01-04-21",
        fecha_pago: "01-04-21",
        nombre_conductor: "nombre conductor",
        pdf_multa: "",
        pdf_pago_multa: ""
    }
];

const LOP = [
    {
        key: "patente",
        label: "Patente",
        sortable: true,
    },
    {
        key: "rol",
        label: "Rol",
        sortable: true,
    },
    {
        key: "valor",
        label: "Valor",
        sortable: true,
    },
    {
        key: "juzgado",
        label: "Nro. juzgado",
        sortable: true,
    },
    {
        key: "fechaInfraccion",
        label: "Fecha infracción",
        sortable: true,
    },
    {
        key: "hora",
        label: "Hora",
        sortable: true,
    },
    {
        key: "tipoInfraccion",
        label: "Tipo de infracción",
        sortable: true,
    },
    {
        key: "fechaRecepcion",
        label: "Fecha de recepción",
        sortable: true,
    },
    {
        key: "fechaPago",
        label: "Fecha de pago",
        sortable: true,
    },
    {
        key: "idDocumentoMulta",
        label: "Descargar documento",
        sortable: false,
    },
    {
        key: "idDocumentoPago",
        label: "Descargar pago documento",
        sortable: false,
    }

];

const LOPData = [
    {
        patente: "AAA123",
        rol: "Rol 1",
        valor: "$ 13.000",
        juzgado: "Nº 1",
        fecha_infraccion: "01-04-21",
        hora: "10:00:00",
        tipo_infraccion: "Mal parqueo",
        fecha_recepcion: "01-04-21",
        fecha_pago: "01-04-21",
        pdf_multa: "",
        pdf_pago_multa: ""
    }
];

module.exports = {
    RAC,
    RACData,
    LOP,
    LOPData
};